import { createSlice } from '@reduxjs/toolkit'

export const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    cart: null,
    open: false,
    upsells: [],
  },
  reducers: {
    setCart: (state, action) => {
      state.cart = action.payload
    },
    setCartOpen: (state, action) => {
      state.open = action.payload
    },
    setUpsells: (state, action) => {
      state.upsells = action.payload
    },
  },
})

export const { setCart, setCartOpen, setUpsells } = cartSlice.actions

export default cartSlice.reducer
